<template>
    <div class="w-full h-full flex flex-col gap-y-2">
        <div class="border-b border-eblack-300">
            <ul class="flex flex-wrap -mb-px text-sm font-medium text-center text-eblack-950 bg-eblack-100/70 rounded-t-md pt-0.5 px-0.5">
                <li class="me-2">
                    <button 
                    type="button" 
                    @click="tab = 1"
                    v-bind:class="[tab == 1 ? 'bg-white border-b border-eorange-300' : 'border-transparent']"
                    class="inline-flex items-center justify-center p-4 border-b-2  rounded-t-lg hover:text-gray-600 hover:border-gray-300 group">
                        <svg 
                        class="w-4 h-4 me-2 text-gray-400 group-hover:text-gray-500 " aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 18 20">
                            <path d="M16 1h-3.278A1.992 1.992 0 0 0 11 0H7a1.993 1.993 0 0 0-1.722 1H2a2 2 0 0 0-2 2v15a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V3a2 2 0 0 0-2-2Zm-3 14H5a1 1 0 0 1 0-2h8a1 1 0 0 1 0 2Zm0-4H5a1 1 0 0 1 0-2h8a1 1 0 1 1 0 2Zm0-5H5a1 1 0 0 1 0-2h2V2h4v2h2a1 1 0 1 1 0 2Z"/>
                        </svg>{{ $t("provider.auto.formulario") }}</button>
                </li>
                <li class="me-2">
                    <button 
                    type="button" 
                    @click="tab = 2"
                    v-bind:class="[tab == 2 ? 'bg-white border-b border-eorange-300' : 'border-transparent ']"
                    v-if="showDetails"
                    class="inline-flex items-center justify-center p-4 border-b-2 rounded-t-lg hover:text-gray-600 hover:border-gray-300 group">
                        <svg class="w-4 h-4 me-2 text-gray-400 group-hover:text-gray-500" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24">
                            <path fill-rule="evenodd" d="M4.857 3A1.857 1.857 0 0 0 3 4.857v4.286C3 10.169 3.831 11 4.857 11h4.286A1.857 1.857 0 0 0 11 9.143V4.857A1.857 1.857 0 0 0 9.143 3H4.857Zm10 0A1.857 1.857 0 0 0 13 4.857v4.286c0 1.026.831 1.857 1.857 1.857h4.286A1.857 1.857 0 0 0 21 9.143V4.857A1.857 1.857 0 0 0 19.143 3h-4.286Zm-10 10A1.857 1.857 0 0 0 3 14.857v4.286C3 20.169 3.831 21 4.857 21h4.286A1.857 1.857 0 0 0 11 19.143v-4.286A1.857 1.857 0 0 0 9.143 13H4.857ZM18 14a1 1 0 1 0-2 0v2h-2a1 1 0 1 0 0 2h2v2a1 1 0 1 0 2 0v-2h2a1 1 0 1 0 0-2h-2v-2Z" clip-rule="evenodd"/>
                        </svg>{{ $t("provider.auto.servicios") }}</button>
                </li>
            </ul>
        </div>
        <FormTab v-if="tab==1" :handleRequestInitData="handleRequestInitData" :provider="provider" :close-modal="closeModal" :show-details="showDetails" :overlayService="overlayService" />
        <ServiceTab v-if="tab==2" :provider="provider"/>
    </div>
</template>

<script>
    import FormTab from '../components/FormTab.vue';
    import ServiceTab from '../components/ServiceTab.vue';

    export default {
        name:"ProviderForm",
        props:['closeModal','provider','handleRequestInitData','showDetails','overlayService'],
        data(){
            return {
                tab:1
            }
        },
        components:{
            FormTab,
            ServiceTab
        },
        methods:{
        },
        mounted(){
        }
    }
</script>

<style lang="scss" scoped>

</style>